import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PropTypes from 'prop-types';
import normalizeCss from 'normalize.css';
import { withTranslation } from 'react-i18next';

import s from './Layout.css';
import Header from '../Header';
import Footer from '../Footer';
import Popup from '../Popup';
import { useLayoutLogic } from './Layout.functions';
import LayoutLoader from './LayoutLoader';
import LayoutBody from './LayoutBody';

/**
 * Composant Layout - Structure principale de l'application
 *
 * @component
 * @param {Object} props - Props du composant
 * @param {React.ReactNode} props.children - Contenu à afficher dans le layout
 * @param {Object} props.context - Contexte de l'application
 * @param {Function} props.t - Fonction de traduction
 * @returns {JSX.Element} Composant rendu
 */
const Layout = ({ children, context, t, hideHeader = false, ...props }) => {
  // Utilisation de la logique métier extraite
  const { state, handlers } = useLayoutLogic({ context });

  // Rendu du loader pendant le chargement
  if (!state.loaded) {
    return <LayoutLoader className={s.loader} />;
  }

  return (
    <>
      {!hideHeader && (
        <Header context={context} me={state.me} emitEvent={handlers.emitEvent} />
      )}
      <Popup t={t} me={state.me} context={context} />
      <LayoutBody
        className={s.body}
        state={state}
        emitEvent={handlers.emitEvent}
      >
        {children}
      </LayoutBody>
      {/*<Footer />*/}
    </>
  );
};

// PropTypes complets
Layout.propTypes = {
  children: PropTypes.node.isRequired,
  context: PropTypes.shape({
    fetch: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(s, normalizeCss)(Layout));
